import { JOURNEY_POSTBACK_VARIABLE } from '../constants';
import { extractParamsFromJson } from './integration.helper';

export function isValidJson(json: string): boolean {
  try {
    JSON.parse(json);
    return true;
  } catch {
    return false;
  }
}

export function isValidJsonWithParams(json: string): boolean {
  const jsonParams = extractParamsFromJson(json);
  for (const param of jsonParams) {
    const token = `{{${param}}}`;
    if (json.includes(token)) {
      // Variables that are strings by definition
      if (
        token === JOURNEY_POSTBACK_VARIABLE.CAMPAIGN_TYPE ||
        token === JOURNEY_POSTBACK_VARIABLE.CUSTOMER_ID ||
        token === JOURNEY_POSTBACK_VARIABLE.UNIX_TIME ||
        token === JOURNEY_POSTBACK_VARIABLE.UUID_V4 ||
        token === JOURNEY_POSTBACK_VARIABLE.ISO_DATE
      ) {
        json = json.replaceAll(token, 'SPONGE BOB');
      } else {
        // Anything else could be a number
        json = json.replaceAll(token, '314159');
      }
    }
  }
  return isValidJson(json);
}
